import React, { useState } from "react";
import {
  Box,
  Button,
  Typography,
  MenuItem,
  Select,
  FormControl,
  TextField,
  SelectChangeEvent,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Divider,
} from "@mui/material";
import { styled } from "@mui/material/styles";
import Cake from "./Cake";
import ScrollableContainer from "./ScrollableContainer";
import campo3 from "../../../../assets/campo3.png";
import campo4 from "../../../../assets/campo4.png";
import campo5 from "../../../../assets/campo5.png";
import chiffoncakeMumu from "../../../../assets/chiffoncake-mumu.jpg";
import chiffoncakeMorango from "../../../../assets/chiffoncake-morango.jpeg";
import chiffoncakeBelgano from "../../../../assets/chiffoncake-belgano.jpeg";
import chiffoncakeSnickers from "../../../../assets/chiffoncake-snickers.jpeg";

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const spaces = [
  {
    id: 2,
    name: `Campo 3`,
    capacity: "MAX: 20 pessoas",
    image: campo3,
  },
  {
    id: 3,
    name: "Campo 4",
    capacity: "MAX: 20 pessoas",
    image: campo4,
  },
  {
    id: 4,
    name: "Campo 5",
    capacity: "MAX: 50 pessoas",
    image: campo5,
  },
];

const cakes = [
  {
    id: 1,
    name: "Mumu",
    image: chiffoncakeMumu,
  },
  {
    id: 2,
    name: "Morango",
    image: chiffoncakeMorango,
  },
  {
    id: 3,
    name: "Belgano",
    image: chiffoncakeBelgano,
  },
  {
    id: 4,
    name: "Snickers",
    image: chiffoncakeSnickers,
  },
];

/* const decors = [
  {
    id: 1,
    name: "Verde",
    image: mesaPostaVerde,
  },
  {
    id: 2,
    name: "Vermelho",
    image: mesaPostaVermelho,
  },
  {
    id: 3,
    name: "Preto",
    image: mesaPostaPreto,
  },
]; */

// WhatsApp da central de reservas da Kroissant.
const RESERVA_WHATSAPP = "5583981957808";
const RESERVA_WHATSAPP_DISPLAY = "+55 83 98195-7808";

// Bolo (chiffon cake) section is hidden for now.
// Flip to true to bring the flavour picker + size select back.
const SHOW_CAKES = false;

const ReservaResumoLinha: React.FC<{ rotulo: string; valor: string }> = ({
  rotulo,
  valor,
}) => (
  <Box sx={{ display: "flex", justifyContent: "space-between", gap: "16px" }}>
    <Typography variant="body1" sx={{ fontWeight: "bold" }}>
      {rotulo}
    </Typography>
    <Typography variant="body1" sx={{ textAlign: "right" }}>
      {valor}
    </Typography>
  </Box>
);

const CenteredBox = styled(Box)({
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  flexDirection: "column",
  minHeight: "100vh",
  padding: "20px",
});

const Reserva: React.FC = () => {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [selectedSpace] = useState<number | null>(null);
  const [selectedCake, setSelectedCake] = useState<number | null>(null);
  const [cakeSize, setCakeSize] = useState<string>("");
  const [formData, setFormData] = useState({
    name: "",
    phone: "",
    date: "",
    time: "",
    numberOfPeople: "",
  });
  const [error, setError] = useState<string | null>(null);
  // Confirmation modal: "confirm" asks the user to review, "fallback" is shown
  // after we try to open WhatsApp so they can copy the message by hand.
  const [confirmOpen, setConfirmOpen] = useState(false);
  const [confirmStage, setConfirmStage] = useState<"confirm" | "fallback">(
    "confirm",
  );
  const [pendingMessage, setPendingMessage] = useState("");
  const [copied, setCopied] = useState(false);

  const handleCakeClick = (id: number) => {
    if (id === selectedCake) {
      setSelectedCake(null);
      setCakeSize(""); // Reset cake size when cake is deselected
    } else {
      setSelectedCake(id);
    }
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSizeChange = (event: SelectChangeEvent<string>) => {
    setCakeSize(event.target.value as string);
  };

  /* async function twilioSendMsg(
    whatsappNum: string,
    templateData: TemplateData
  ) {
    const ACC_SID = "AC26e2dfddcd1d71e0ad52cb91e9b83758";
    const AUTH_TOKEN = "65d492c08c3c1a7ef4bf5db5a94a1b6b";
    const client = new Twilio(ACC_SID, AUTH_TOKEN);
    const senderNum = "MG7c42b16e4117a4338e6782d496251ae9";
    const templateSid = "HXd659e3b37514ca2157c08714b84ba84f";
    try {
      // Send the message using the Twilio API and the selected template
      await client.messages.create({
        from: senderNum, // Twilio WhatsApp number
        to: whatsappNum, // Recipient's WhatsApp number
        contentSid: templateSid,
        contentVariables: JSON.stringify(templateData),
      });
    } catch (err) {
      console.error("Error sending message:", err);
    }
  } */

  const buildMessage = () =>
    `*RESERVA KROISSANT*\n\n*Nome Completo*: ${formData.name.toUpperCase()}\n*Numero WhatsApp*: ${formData.phone.toUpperCase()}\n\n*Data Reserva*: ${formData.date.toUpperCase()}\n*Hora Chegada*: ${formData.time.toUpperCase()}\n*Numero de Pessoas*: ${
      formData.numberOfPeople
    }${
      selectedCake
        ? `\n\n*Bolo Chiffon*: ${cakes
            .find((cake) => cake.id === selectedCake)
            ?.name.toUpperCase()}\n*Tamanho*: ${cakeSize.toUpperCase()}`
        : ""
    }\n\n*TAXA DE GARANTIA - PENDENTE*`;

  // Validates the form, then opens the confirmation modal. Nothing is sent to
  // WhatsApp until the user confirms.
  const handleSolicitarReserva = () => {
    /* if (!selectedSpace) {
      setError("Por favor, selecione um espaço.");
      return;
    } */
    if (
      !formData.name ||
      !formData.phone ||
      !formData.date ||
      !formData.time ||
      !formData.numberOfPeople
    ) {
      setError("Por favor, preencha todos os campos abaixo.");
      return;
    }
    if (selectedCake && !cakeSize) {
      setError("Por favor, selecione o tamanho do bolo.");
      return;
    }

    setError(null);

    // try {
    //   const response = await fetch(COMPRA_ROUTES.RESERVA(), {
    //     method: "POST",
    //     headers: new Headers({
    //       "bypass-tunnel-reminder": "69420",
    //       "ngrok-skip-browser-warning": "69420",
    //       "Content-Type": "application/json",
    //     }),
    //     body: JSON.stringify(templateData),
    //   });
    //   if (!response.ok) {
    //     alert(
    //       "Servidor da reserva retornado com erro, por favor entre em contato com o suporte +5583991409999"
    //     );
    //   } else {
    //     alert(
    //       "Reserva feita com sucesso! Agora só aguardar o gestor entrar em contato :)"
    //     );
    //   }
    // } catch (err) {
    //   alert(
    //     "Erro ao enviar a reserva, entre em contato com o suporte +5583991409999"
    //   );
    // }

    setPendingMessage(buildMessage());
    setConfirmStage("confirm");
    setCopied(false);
    setConfirmOpen(true);
  };

  // Opens the reservation WhatsApp with the message pre-filled, then moves the
  // modal to the fallback stage so the user can copy it by hand if the app
  // never opened (blocked pop-up, no WhatsApp installed, desktop without web).
  const handleConfirmReserva = () => {
    const whatsappUrl = `https://wa.me/${RESERVA_WHATSAPP}?text=${encodeURIComponent(
      pendingMessage
    )}`;

    window.open(whatsappUrl, "_blank");

    setConfirmStage("fallback");
  };

  const handleCopyMessage = async () => {
    try {
      await navigator.clipboard.writeText(pendingMessage);
      setCopied(true);
    } catch {
      // Clipboard blocked (insecure context or denied permission): the message
      // is on screen and selectable, so the user can still copy it manually.
      setCopied(false);
    }
  };

  // Closing after a send clears the form, the way the old reload did.
  const handleCloseConfirm = () => {
    const sent = confirmStage === "fallback";
    setConfirmOpen(false);
    setConfirmStage("confirm");
    setCopied(false);
    if (sent) {
      setFormData({
        name: "",
        phone: "",
        date: "",
        time: "",
        numberOfPeople: "",
      });
      setSelectedCake(null);
      setCakeSize("");
      setPendingMessage("");
    }
  };

  return (
    <CenteredBox>
      <Typography
        variant="h3"
        gutterBottom
        align="center"
        sx={{ marginBottom: "20px" }}
      >
        Reserva sua experiência
      </Typography>

      <Box
        sx={{
          backgroundColor: "#f5f5f5",
          borderRadius: "8px",
          padding: "20px",
          marginBottom: "40px",
          maxWidth: "600px",
          width: "100%",
        }}
      >
        <Typography variant="h5" gutterBottom sx={{ fontWeight: "bold" }}>
          Regras
        </Typography>
        <Box component="ul" sx={{ margin: 0, paddingLeft: "20px" }}>
          <Typography component="li" variant="body1" sx={{ marginBottom: "8px" }}>
            A escolha do espaço não é liberada e será alocada pelo sistema automaticamente.
          </Typography>
          <Typography component="li" variant="body1" sx={{ marginBottom: "8px" }}>
            Caso quiser encomendar bolo nessa reserva, o bolo tera 20% desconto 
          </Typography>
          <Typography component="li" variant="body1" sx={{ marginBottom: "8px" }}>
            Reservas a partir de 5 pessoas
          </Typography>
          <Typography component="li" variant="body1" sx={{ marginBottom: "8px" }}>
            Tolerância de chegada: 10 minutos
          </Typography>
          <Typography component="li" variant="body1" sx={{ marginBottom: "8px" }}>
            Taxa de R$ 50 para garantir a reserva. O valor pode ser aplicado na conta de pagamento. Caso a reserva for cancelada, o valor não será estornado
          </Typography>
          <Typography component="li" variant="body1">
            Apenas é permitido entrada externa de bolo aniversariante. Bebidas, doces e salgados não serão permitidos
          </Typography>
        </Box>
      </Box>
{/* 
      <Typography variant="h4" gutterBottom>
        Espaços
      </Typography>
      <Typography variant="body1" gutterBottom textAlign={"center"}>
        <br />
        *REGRA 1: tolerância para chegada na reserva com atraso no máximo de
        30mins*
        <br />
        *REGRA 2: proibído levar comida e/ou bebida por fora. Exceto bolos
        aniversariantes.*
        <br />
        *REGRA 3: caso tiver mesas sobrando no espaço, os clientes normais podem
        sentar.*
        <br />
        <br />
        Escolha gratuitamente um dos nossos espaços exclusivos para tornar o seu
        evento inesquecível.
      </Typography>
      <ScrollableContainer
        id="spaces-container"
        scrollable={spaces.length > 2}
        onScroll={() => {}}
      >
       {spaces.map((space) => (
          <Box key={space.id} sx={{ marginBottom: "20px" }}>
            <Space
              id={space.id}
              name={space.name}
              image={space.image}
              selected={selectedSpace === space.id}
              onClick={() => handleSpaceClick(space.id)}
            />
            <Typography textAlign={"center"}>{space.capacity}</Typography>
          </Box>
        ))}
      </ScrollableContainer>

      <Typography variant="h4" gutterBottom>
        Mesas Postas
      </Typography>
      <Typography variant="body1" gutterBottom>
        Opcionalmente, escolha uma decoração especial para tornar a sua
        experiência ainda mais completa. *Qualquer mesa posta custa 10 reais por
        pessoa.*
      </Typography>
      <ScrollableContainer
        id="decors-container"
        scrollable={decors.length > 2}
        onScroll={() => {}}
      >
        {decors.map((decor) => (
          <Box key={decor.id} sx={{ marginBottom: "20px" }}>
            <Decor
              id={decor.id}
              name={decor.name}
              image={decor.image}
              selected={selectedDecor === decor.id}
              onClick={() => handleDecorClick(decor.id)}
            />
          </Box>
        ))}
      </ScrollableContainer>*/}

      {SHOW_CAKES && (
        <>
        <Typography variant="h4" gutterBottom>
          Bolos (OPCIONAL)
        </Typography>
        <Typography variant="body1" gutterBottom>
          Opcionalmente, você pode incluir na sua reserva um bolo para comemorar
          perfeitamente sua festa! *Escolhe um dos sabores abaixo, para ver
          preço.*
        </Typography>
        <ScrollableContainer
          id="cakes-container"
          scrollable={cakes.length > 2}
          onScroll={() => {}}
        >
          {cakes.map((cake) => (
            <Box key={cake.id} sx={{ marginBottom: "20px" }}>
              <Cake
                id={cake.id}
                name={cake.name}
                image={cake.image}
                selected={selectedCake === cake.id}
                onClick={() => handleCakeClick(cake.id)}
              />
            </Box>
          ))}
        </ScrollableContainer>
        </>
      )}

      {SHOW_CAKES && selectedCake !== null && (
        <FormControl
          fullWidth
          margin="normal"
          sx={{ marginTop: "5px", width: "100%", maxWidth: "600px" }}
        >
          <Typography variant="h5" gutterBottom>
            Escolhe o tamanho do bolo
          </Typography>
          <Select
            labelId="cake-size-label"
            value={cakeSize}
            onChange={handleSizeChange}
          >
            <MenuItem value="Grande">Grande R$ 160 (20 pessoas)</MenuItem>
            <MenuItem value="Pequeno">Pequeno R$ 90 (10 pessoas)</MenuItem>
          </Select>
        </FormControl>
      )}

      <Box
        component="form"
        sx={{ marginTop: "20px", width: "100%", maxWidth: "600px" }}
      >
        <Typography variant="h5" gutterBottom>
          Formulário p/ reserva
        </Typography>
        {error && (
          <Typography color="error" sx={{ marginTop: "10px" }}>
            {error}
          </Typography>
        )}

        <TextField
          label="Nome Completo"
          name="name"
          value={formData.name}
          onChange={handleChange}
          fullWidth
          margin="normal"
        />
        <TextField
          label="Número de WhatsApp"
          name="phone"
          value={formData.phone}
          onChange={handleChange}
          fullWidth
          margin="normal"
        />
        <TextField
          label="Quantidade de Pessoas"
          name="numberOfPeople"
          value={formData.numberOfPeople}
          onChange={handleChange}
          type="number"
          fullWidth
          margin="normal"
        />
        <TextField
          label="Data"
          name="date"
          value={formData.date}
          onChange={handleChange}
          type="date"
          fullWidth
          margin="normal"
          InputLabelProps={{ shrink: true }}
        />
        <TextField
          label="Horário"
          name="time"
          value={formData.time}
          onChange={handleChange}
          type="time"
          fullWidth
          margin="normal"
          InputLabelProps={{ shrink: true }}
        />
        <Button
          variant="contained"
          color="secondary"
          onClick={handleSolicitarReserva}
          sx={{ marginTop: "20px", width: "100%", maxWidth: "600px" }}
        >
          Solicitar Reserva
        </Button>
        <Typography variant="body1" gutterBottom marginTop={"10px"}>
          Ao clicar em 'SOLICITAR RESERVA', você poderá conferir os dados antes
          de enviar. Depois de confirmar, abrimos o WhatsApp de reservas da
          Kroissant ({RESERVA_WHATSAPP_DISPLAY}) com a mensagem já pronta —
          basta apertar enviar por lá. *Caso não for retornado dentro de 3 horas
          ou se tiver dúvidas, pode contar com ele via whatsapp{" "}
          {RESERVA_WHATSAPP_DISPLAY}.*
        </Typography>
      </Box>

      <Dialog
        open={confirmOpen}
        onClose={handleCloseConfirm}
        fullWidth
        maxWidth="sm"
      >
        {confirmStage === "confirm" ? (
          <>
            <DialogTitle>Confirme os dados da sua reserva</DialogTitle>
            <DialogContent dividers>
              <DialogContentText sx={{ marginBottom: "16px" }}>
                Confira tudo com atenção. Ao confirmar, vamos abrir o WhatsApp
                de reservas da Kroissant ({RESERVA_WHATSAPP_DISPLAY}) com esta
                mensagem já preenchida — a reserva só é registrada depois que
                você enviar a mensagem por lá.
              </DialogContentText>
              <Box
                sx={{
                  backgroundColor: "#f5f5f5",
                  borderRadius: "8px",
                  padding: "16px",
                }}
              >
                <ReservaResumoLinha rotulo="Nome" valor={formData.name} />
                <ReservaResumoLinha rotulo="WhatsApp" valor={formData.phone} />
                <ReservaResumoLinha rotulo="Data" valor={formData.date} />
                <ReservaResumoLinha rotulo="Horário" valor={formData.time} />
                <ReservaResumoLinha
                  rotulo="Pessoas"
                  valor={formData.numberOfPeople}
                />
                {selectedCake !== null && (
                  <>
                    <Divider sx={{ marginY: "8px" }} />
                    <ReservaResumoLinha
                      rotulo="Bolo"
                      valor={
                        cakes.find((cake) => cake.id === selectedCake)?.name ||
                        ""
                      }
                    />
                    <ReservaResumoLinha rotulo="Tamanho" valor={cakeSize} />
                  </>
                )}
              </Box>
            </DialogContent>
            <DialogActions>
              <Button onClick={handleCloseConfirm} color="inherit">
                Cancelar
              </Button>
              <Button
                onClick={handleConfirmReserva}
                variant="contained"
                color="secondary"
              >
                Confirmar e abrir WhatsApp
              </Button>
            </DialogActions>
          </>
        ) : (
          <>
            <DialogTitle>Abrimos o WhatsApp da Kroissant</DialogTitle>
            <DialogContent dividers>
              <DialogContentText sx={{ marginBottom: "16px" }}>
                Sua mensagem foi aberta em uma nova aba do WhatsApp de reservas
                ({RESERVA_WHATSAPP_DISPLAY}). <strong>Não esqueça de apertar
                enviar por lá</strong> — sem isso a reserva não chega até nós.
              </DialogContentText>
              <DialogContentText sx={{ marginBottom: "16px" }}>
                <strong>O WhatsApp não abriu?</strong> Copie a mensagem abaixo e
                envie manualmente para o número{" "}
                <strong>{RESERVA_WHATSAPP_DISPLAY}</strong>.
              </DialogContentText>
              <TextField
                value={pendingMessage}
                multiline
                fullWidth
                minRows={8}
                InputProps={{ readOnly: true }}
                onFocus={(e) => e.target.select()}
              />
              <Button
                onClick={handleCopyMessage}
                variant="outlined"
                fullWidth
                sx={{ marginTop: "12px" }}
              >
                {copied ? "Mensagem copiada!" : "Copiar mensagem"}
              </Button>
            </DialogContent>
            <DialogActions>
              <Button onClick={handleConfirmReserva} color="inherit">
                Abrir WhatsApp novamente
              </Button>
              <Button
                onClick={handleCloseConfirm}
                variant="contained"
                color="secondary"
              >
                Concluir
              </Button>
            </DialogActions>
          </>
        )}
      </Dialog>
    </CenteredBox>
  );
};

export default Reserva;
